import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { RESET } from 'action-creators/generic';
import { USER_LOYALTIES } from 'action-creators/user';

export interface UserLoyaltiesState {
  loyalties: UserLoyalty[] | null;
}

export interface UserLoyalty {
  id: string;
  userId: string;
  name: string;
  lastName: string;
  loyaltyNumber: string;
  loyaltyName: string;
  airlineCode: string;
}

const initialState: UserLoyaltiesState = {
  loyalties: [],
};

const reducer: Reducer<UserLoyaltiesState> = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOYALTIES:
      return {
        ...state,
        loyalties: action.payload,
      };
    case RESET: {
      return initialState;
    }

    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'userLoyalties',
  blacklist: ['isLoading', 'error'],
};

export default persistReducer(persistConfig, reducer);
